import { localDataService } from '../services/localDataService';
import {
  AddNewPresentationToTaskParams,
  AddNewPresentationToTaskResult,
} from '../types/priceTypes';
import { TaskStatus } from '../pages/inspector/timelineItem';

export const addNewPresentationToTask = async ({
  productsFromTask,
  enrichedProduct,
  currentCarouselIndex,
  taskData,
}: AddNewPresentationToTaskParams): Promise<AddNewPresentationToTaskResult> => {
  const currentList = productsFromTask || [];
  const insertIndex = Math.min(currentCarouselIndex + 1, currentList.length);

  const updatedProductsFromTask = [
    ...currentList.slice(0, insertIndex),
    enrichedProduct,
    ...currentList.slice(insertIndex),
  ];

  const updatedProductRefIds = updatedProductsFromTask.map((p: any) => p?.refId || p);
  const newStatus =
    taskData?.status !== TaskStatus.IN_PROGRESS ? TaskStatus.IN_PROGRESS : taskData?.status;

  let updatedTask = taskData;
  if (taskData?.refId) {
    updatedTask = await localDataService.update('task', taskData.refId, {
      productRefIds: updatedProductRefIds,
      status: newStatus,
      updateTime: Date.now(),
    });
  }

  return {
    updatedProductsFromTask,
    updatedTask,
    insertIndex,
  };
};
